import { createSlice } from "@reduxjs/toolkit";
import { ExportToExcel } from "../thunks/reportExcelThunks";

interface ReportExcelState {
  loading: boolean;
  error: string | null;
  success: boolean;
  downloadUrl: string | null;
  fileName: string | null;
}

const initialState: ReportExcelState = {
  loading: false,
  error: null,
  success: false,
  downloadUrl: null,
  fileName: null,
};

const reportExcelSlice = createSlice({
  name: "reportExcel",
  initialState,
  reducers: {
    resetExcelExport: (state) => {
      state.loading = false;
      state.error = null;
      state.success = false;
      state.downloadUrl = null;
      state.fileName = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(ExportToExcel.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(ExportToExcel.fulfilled, (state, action) => {
        state.loading = false;
        state.success = true;
        state.downloadUrl = action.payload.downloadUrl || null;
        state.fileName = action.payload.fileName || null;
      })
      .addCase(ExportToExcel.rejected, (state, action) => {
        state.loading = false;
        state.error = (action.payload as string) || "שגיאה בייצוא Excel";
      });
  },
});

export const { resetExcelExport } = reportExcelSlice.actions;
export default reportExcelSlice.reducer;
